export default (function () {
  return {
    currentRoute: null,
    previousRoute: null
  };
});